/**
 * Card — the standard white surface used across the marketer view.
 *
 * Visual defaults align with the Antd Card token from `App.tsx`
 * (borderRadius 16, slate-200 border, the same boxShadow) so the marketer
 * view feels native to the dashboard.
 */

import React from 'react';
import { THEME } from '../config/theme';

export interface CardProps {
  children: React.ReactNode;
  /** Padding around the card body. Pass 0 for full-bleed inner layouts. */
  pad?: number;
  /** Additional inline styles merged after the base. */
  style?: React.CSSProperties;
  /** Extra class names (we use this for `.lift` hover effects). */
  className?: string;
  /** Optional click handler — sets `cursor: pointer` automatically. */
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const Card: React.FunctionComponent<CardProps> = ({
  children,
  pad = 24,
  style,
  className,
  onClick,
}) => (
  <div
    className={className ? `be-card ${className}` : 'be-card'}
    onClick={onClick}
    style={{
      background: THEME.bgCard,
      borderRadius: 16,
      padding: pad,
      boxShadow: THEME.cardShadow,
      border: `1px solid ${THEME.border}`,
      cursor: onClick ? 'pointer' : undefined,
      ...style,
    }}
  >
    {children}
  </div>
);
